module.exports = __webpack_public_path__ + "static/media/error-icon.266f2999.png";